import { produce } from 'immer';
import { EVENT_DATE, REMOVE_TABLE_ID, STORE_RESTAURANT_DETAILS, STORE_TABLE_ID } from './persistorConstants';

const initialPersistorState: any = {
  persistedRestaurantDetails: null,
  tableId: "",
  eventDate: null,
};

export default function persistorReducer(state = initialPersistorState, action: any) {
  return produce(state, (draft: any) => {
    switch (action.type) {
      case STORE_RESTAURANT_DETAILS:
        draft.persistedRestaurantDetails = action.payload;
        break;

      case STORE_TABLE_ID:
        draft.tableId = action.payload;
        break;

      case REMOVE_TABLE_ID:
        draft.tableId = "";
        break;

      case EVENT_DATE:
        draft.eventDate = action.payload;
        break;

      default:
        break;
    }
  });
}
